function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  fill: "currentColor",
  strokeMiterlimit: "10",
  strokeWidth: ".25",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "18.25",
  r: ".8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7 4.75h-1.45a.35.35 0 00-.4.35l.85 9.5a.35.35 0 00.35.35h0a.35.35 0 00.35-.35l.65-9.45a.35.35 0 00-.4-.4z"
}));